import { z } from 'zod';

export const LocaleSchema = z.enum(['el', 'en']);
export type Locale = z.infer<typeof LocaleSchema>;

/** A single translation of a Specialization — sent from the Admin CMS. */
export const SpecializationTranslationSchema = z.object({
  locale: LocaleSchema,
  name: z.string().min(1).max(120),
  description: z.string().max(2000).optional(),
});
export type SpecializationTranslation = z.infer<typeof SpecializationTranslationSchema>;

/** Category surfaced in the client app + matching engine. */
export const SpecializationSchema = z.object({
  id: z.string().cuid(),
  slug: z.string().min(1).max(60),
  isActive: z.boolean(),
  sortOrder: z.number().int(),
  translations: z.array(SpecializationTranslationSchema).min(1),
});
export type Specialization = z.infer<typeof SpecializationSchema>;

export const CreateSpecializationSchema = SpecializationSchema.omit({ id: true });
export type CreateSpecializationInput = z.infer<typeof CreateSpecializationSchema>;

/** PATCH /api/v1/admin/cms/specializations/:id — every field optional. */
export const UpdateSpecializationSchema = z.object({
  slug: z.string().min(1).max(60).optional(),
  isActive: z.boolean().optional(),
  sortOrder: z.number().int().optional(),
  translations: z.array(SpecializationTranslationSchema).min(1).optional(),
});
export type UpdateSpecializationInput = z.infer<typeof UpdateSpecializationSchema>;

/** GET /api/v1/admin/cms/specializations (all, incl. inactive) and the public GET /api/v1/specializations (active only). */
export const SpecializationListResponseSchema = z.object({
  specializations: z.array(SpecializationSchema),
});
export type SpecializationListResponse = z.infer<typeof SpecializationListResponseSchema>;

export const SpecializationResponseSchema = z.object({ specialization: SpecializationSchema });
export type SpecializationResponse = z.infer<typeof SpecializationResponseSchema>;
